import {
  PropTypeMediaEntry,
  PropTypeMediaTableColumns,
} from "fleet/prop-types";
import PropTypes from "prop-types";
import React from "react";
import Badge from "react-bootstrap/Badge";
import { Column, Table } from "ui/table";
import { configReducer } from "util/array";
import { formatTags } from "util/table-format";

import { formatPreview, formatUploadDate, sortByUploadDate } from "./utils";

class MediaTable extends React.PureComponent {
  static get propTypes() {
    return {
      actions: PropTypes.node,
      clickable: PropTypes.bool,
      data: PropTypes.arrayOf(PropTypeMediaEntry),
      extraColumns: PropTypes.node,
      excludeColumns: PropTypes.arrayOf(PropTypeMediaTableColumns),
      formatters: PropTypes.object,
      getRef: PropTypes.func,
      highlight: PropTypes.number,
      options: PropTypes.object,
      selectOptions: PropTypes.object,
      toolbar: PropTypes.node,
      toolbarWidth: PropTypes.number,
    };
  }

  static get defaultProps() {
    return {
      clickable: false,
      data: [],
      excludeColumns: [],
      formatters: {},
      options: {},
    };
  }

  constructor(props) {
    super(props);

    this.tableOpts = {
      defaultSortName: "uploadDate",
      defaultSortOrder: "desc",
    };

    this.rowHighlight = this.rowHighlight.bind(this);

    const LabelTag = <Badge variant="danger" />;
    const defaultFormatter = (val) => val;

    this.defaultFormatters = {
      name: defaultFormatter,
      friendlyType: defaultFormatter,
      tag: formatTags.bind(null, LabelTag),
      uploadDate: formatUploadDate,
      url: formatPreview,
    };
  }

  rowHighlight(row, rowIdx) {
    const { clickable, highlight } = this.props;
    const highlightClass = rowIdx === highlight ? "rbs-highlight" : "";
    const clickClass = clickable ? "clickable" : "";

    return `${highlightClass} ${clickClass}`;
  }

  render() {
    const {
      actions,
      data,
      excludeColumns,
      extraColumns,
      formatters,
      getRef,
      selectOptions,
      options,
      toolbar,
      toolbarWidth,
    } = this.props;

    const excluded = excludeColumns.reduce(configReducer, {});

    const format = {
      ...this.defaultFormatters,
      ...formatters,
    };

    const tableOpts = {
      ...this.tableOpts,
      ...options,
    };

    return (
      <div className="media-table">
        <Table
          actions={actions}
          data={data}
          hover={true}
          options={tableOpts}
          pagination={true}
          rowClasses={this.rowHighlight}
          setRef={getRef}
          search={true}
          selectRow={selectOptions}
          toolbar={toolbar}
          toolbarWidth={toolbarWidth}
        >
          <Column key="id" dataField="id" hidden={true} isKey={true}>
            ID
          </Column>
          {!excluded.url && (
            <Column
              key="url"
              dataAlign="center"
              dataField="url"
              dataFormat={format.url}
              width="120px"
            >
              Preview
            </Column>
          )}
          {!excluded.name && (
            <Column
              key="name"
              dataField="displayName"
              dataFormat={format.name}
              dataSort={true}
            >
              Name
            </Column>
          )}
          {!excluded.tag && (
            <Column
              key="tag"
              dataAlign="center"
              dataField="tag"
              dataFormat={format.tag}
              dataSort={true}
              width="150px"
            >
              Creative Category
            </Column>
          )}
          {!excluded.friendlyType && (
            <Column
              key="friendlyType"
              dataAlign="center"
              dataField="friendlyType"
              dataFormat={format.friendlyType}
              dataSort={true}
              width="150px"
            >
              Type
            </Column>
          )}
          {!excluded.uploadDate && (
            <Column
              key="uploadDate"
              dataAlign="center"
              dataField="uploadDate"
              dataFormat={format.uploadDate}
              dataSort={true}
              sortFunc={sortByUploadDate}
              width="170px"
            >
              Date Added
            </Column>
          )}
          {extraColumns}
        </Table>
      </div>
    );
  }
}

export { MediaTable };
